import { client } from './client';

export const authenticate = () => client.getSession();
